const SA_COMPANY_COUNTRY_CODES = new Set(['ZAF', 'ZA', 'SOUTH AFRICA', 'RSA'])

export const SOUTH_AFRICA_REGISTRATION_ERROR = 'Invalid South African registration number format. Expected format: YYYY/NNNNNN/NN'
export const INTERNATIONAL_REGISTRATION_ERROR = 'Invalid company registration number. Use letters, numbers, spaces, hyphens, slashes, periods, parentheses, or ampersands only.'

export function normalizeCountryCode(value) {
 if (value === null || value === undefined) return ''
 return String(value).trim().replace(/\s+/g, ' ').toUpperCase()
}

export function isSouthAfricaCompanyCountry(countryCode) {
 return SA_COMPANY_COUNTRY_CODES.has(normalizeCountryCode(countryCode))
}

function hasControlCharacters(value) {
 for (const char of value) {
 const code = char.charCodeAt(0)
 if (code < 32 || code === 127) return true
 }
 return false
}

function hasUnsafePayload(value) {
 const lower = value.toLowerCase()
 return (
 hasControlCharacters(value) ||
 /[<>"'`;]/.test(value) ||
 /<[^>]*>/i.test(value) ||
 /script\s*:/i.test(value) ||
 /javascript\s*:/i.test(value) ||
 /\b(drop|truncate|delete|insert|update|alter)\s+(table|from|into|users|company_accounts)\b/i.test(value) ||
 lower.includes('onerror=') ||
 lower.includes('onload=') ||
 lower.includes('alert(')
 )
}

export function getCompanyRegistrationValidationError(value, countryCode) {
 const normalizedValue = value === null || value === undefined ? '' : String(value).trim()

 if (!normalizedValue) return 'Company registration number is required'
 if (normalizedValue.length < 2) return 'Company registration number must be at least 2 characters'
 if (normalizedValue.length > 64) return 'Company registration number must not exceed 64 characters'
 if (hasUnsafePayload(normalizedValue)) return INTERNATIONAL_REGISTRATION_ERROR

 if (isSouthAfricaCompanyCountry(countryCode)) {
 const saCipcFormat = /^\d{4}\/\d{6}\/\d{2}$/
 return saCipcFormat.test(normalizedValue) ? null : SOUTH_AFRICA_REGISTRATION_ERROR
 }

 const internationalSafeFormat = /^[A-Za-z0-9 .\/()&-]+$/
 return internationalSafeFormat.test(normalizedValue) ? null : INTERNATIONAL_REGISTRATION_ERROR
}

export function validateCompanyRegistrationNumber(value, countryCode) {
 const normalizedValue = value === null || value === undefined ? '' : String(value).trim()
 const error = getCompanyRegistrationValidationError(value, countryCode)
 return {
 valid: error === null,
 normalizedValue,
 error
 }
}